














































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ItoggleEvent } from './CheckBoxTypes';
import Typography from '@/components/atoms/Typography/Typography.vue';

type ToggleLabel = {
  activeLabel: string;
  inactiveLabel: string;
};

@Component({
  components: {
    Typography
  }
})
export default class checkbox extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) toggle!: boolean;
  @Prop({ default: false }) checked!: boolean;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) id?: string;
  @Prop({ default: '' }) hiddenValue!: string;
  @Prop({ default: false }) toggleLabelVisibility!: boolean;
  @Prop({ default: 'start' }) toggleLabelPosition!: 'start' | 'end';
  @Prop({ default: () => ({}), type: Object }) toggleLabel?: ToggleLabel;
  @Prop({ default: 'green' }) color!:
    | 'green'
    | 'yellow'
    | 'blue'
    | 'green-primary';

  @Prop({ default: '' }) dataTippyToggle!: string;

  selected: boolean = this.checked;

  change() {
    this.selected = !this.selected;
    const event: ItoggleEvent = {
      id: this.value,
      state: this.selected
    };
    this.$emit('changed', event);
    this.$emit('input', event.state);
  }

  get isChecked() {
    return this.checked;
  }

  get toggleLabelText() {
    const { activeLabel = 'Enabled', inactiveLabel = 'Disabled' } = this
      .toggleLabel as ToggleLabel;

    return this.checked ? activeLabel : inactiveLabel;
  }
}
